// Canonical list of Linear/project icon names. Lives here (dependency-free) so
// both @productlane/ui (which renders them) and @productlane/api (which validates
// them in the v2 API) share one source of truth without a package cycle.
export enum ProjectIconKeys {
	Accessibility = "Accessibility",
	Africa = "Africa",
	Airplane = "Airplane",
	Alert = "Alert",
	Anchor = "Anchor",
	Android = "Android",
	Apple = "Apple",
	Asia = "Asia",
	Australia = "Australia",
	Bank = "Bank",
	BarChart = "BarChart",
	Basket = "Basket",
	Battery = "Battery",
	Bike = "Bike",
	Bitcoin = "Bitcoin",
	Bolt = "Bolt",
	Book = "Book",
	Bookmark = "Bookmark",
	Briefcase = "Briefcase",
	Brush = "Brush",
	Bucket = "Bucket",
	Bug = "Bug",
	Burger = "Burger",
	Calendar = "Calendar",
	Camera = "Camera",
	Car = "Car",
	Cart = "Cart",
	Chart = "Chart",
	Chat = "Chat",
	Chip = "Chip",
	Clock = "Clock",
	Cloud = "Cloud",
	Coffee = "Coffee",
	Cookie = "Cookie",
	Compass = "Compass",
	Computer = "Computer",
	Cone = "Cone",
	CreditCard = "CreditCard",
	Cross = "Cross",
	Crown = "Crown",
	Cube = "Cube",
	Dashboard = "Dashboard",
	Database = "Database",
	DesignTools = "DesignTools",
	Dna = "Dna",
	Dollar = "Dollar",
	Education = "Education",
	Euro = "Euro",
	Europe = "Europe",
	FaceFlatSmile = "FaceFlatSmile",
	FaceHeartEyes = "FaceHeartEyes",
	Face = "Face",
	FaceId = "FaceId",
	FaceMask = "FaceMask",
	FaceMonocle = "FaceMonocle",
	FaceStarEyes = "FaceStarEyes",
	FaceSunglasses = "FaceSunglasses",
	FaceSurprise = "FaceSurprise",
	FaceTired = "FaceTired",
	FaceTongue = "FaceTongue",
	Favorite = "Favorite",
	Feather = "Feather",
	Fire = "Fire",
	Flower = "Flower",
	Folder = "Folder",
	FootPrint = "FootPrint",
	Gears = "Gears",
	GitHub = "GitHub",
	GitLab = "GitLab",
	Heart = "Heart",
	Home = "Home",
	Image = "Image",
	Inbox = "Inbox",
	Jersey = "Jersey",
	Joystick = "Joystick",
	Label = "Label",
	Leaf = "Leaf",
	LightBulb = "LightBulb",
	Link = "Link",
	Lock = "Lock",
	Mac = "Mac",
	Megaphone = "Megaphone",
	Mic = "Mic",
	MobilePhone = "MobilePhone",
	Modem = "Modem",
	Mountain = "Mountain",
	Moon = "Moon",
	MusicKey = "MusicKey",
	NorthAmerica = "NorthAmerica",
	Page = "Page",
	Paint = "Paint",
	Phone = "Phone",
	PieChart = "PieChart",
	Pin = "Pin",
	Pizza = "Pizza",
	Present = "Present",
	Project = "Project",
	Radar = "Radar",
	Ramen = "Ramen",
	Recycle = "Recycle",
	Robot = "Robot",
	Rocket = "Rocket",
	Scissors = "Scissors",
	Search = "Search",
	Send = "Send",
	Server = "Server",
	Shield = "Shield",
	Ship = "Ship",
	Shop = "Shop",
	Sign = "Sign",
	Skull = "Skull",
	Sound = "Sound",
	SouthAmerica = "SouthAmerica",
	Subscribe = "Subscribe",
	Sun = "Sun",
	Tablet = "Tablet",
	Team = "Team",
	TeeShirt = "TeeShirt",
	Terminal = "Terminal",
	ThumbsDown = "ThumbsDown",
	ThumbsUp = "ThumbsUp",
	Trash = "Trash",
	Tree = "Tree",
	Umbrella = "Umbrella",
	UnhappyFace = "UnhappyFace",
	Users = "Users",
	Video = "Video",
	Watch = "Watch",
	World = "World",
	WindTurbine = "WindTurbine",
	AirTag = "AirTag",
	AlarmClock = "AlarmClock",
	AmericanFootBall = "AmericanFootBall",
	Asterisk = "Asterisk",
	Bandage = "Bandage",
	Basketball = "Basketball",
	Bed = "Bed",
	Boombox = "Boombox",
	Bones = "Bones",
	BookOpen = "BookOpen",
	BowlingBall = "BowlingBall",
	Box = "Box",
	BoxOpen = "BoxOpen",
	Bus = "Bus",
	Calculator = "Calculator",
	CarPool = "CarPool",
	Chemist = "Chemist",
	ClickButton = "ClickButton",
	ClothHanger = "ClothHanger",
	Comodore = "Comodore",
	Connected = "Connected",
	ConstructionBarrier = "ConstructionBarrier",
	Conversation = "Conversation",
	Crane = "Crane",
	CrystalBall = "CrystalBall",
	DesktopWindow = "DesktopWindow",
	Dice = "Dice",
	Dino = "Dino",
	DollarBill = "DollarBill",
	Dumbbell = "Dumbbell",
	ElectricPlug = "ElectricPlug",
	Eraser = "Eraser",
	Extinguisher = "Extinguisher",
	Factory = "Factory",
	Flashlight = "Flashlight",
	FloppyDisk = "FloppyDisk",
	Garage = "Garage",
	Golf = "Golf",
	Hack = "Hack",
	Health = "Health",
	Hear = "Hear",
	Hourglass = "Hourglass",
	Judge = "Judge",
	Ladder = "Ladder",
	LockerRoom = "LockerRoom",
	MacOS = "MacOS",
	MagicWand = "MagicWand",
	Magnet = "Magnet",
	Mask = "Mask",
	MilitaryTruck = "MilitaryTruck",
	MoneyStack = "MoneyStack",
	MovingStaircase = "MovingStaircase",
	MusicTape = "MusicTape",
	NotePad = "NotePad",
	Notified = "Notified",
	PalmTree = "PalmTree",
	Pills = "Pills",
	PingPong = "PingPong",
	Pointer = "Pointer",
	PokerCard = "PokerCard",
	Process = "Process",
	Rank = "Rank",
	Runner = "Runner",
	SafetyKit = "SafetyKit",
	Shrug = "Shrug",
	Signature = "Signature",
	SoccerBall = "SoccerBall",
	Spaces = "Spaces",
	Speaker = "Speaker",
	Spreadsheet = "Spreadsheet",
	Stadium = "Stadium",
	Storm = "Storm",
	Subgroup = "Subgroup",
	Surfer = "Surfer",
	Taxi = "Taxi",
	TennisBall = "TennisBall",
	TextBlock = "TextBlock",
	TextParagraph = "TextParagraph",
	Tower = "Tower",
	TrafficLight = "TrafficLight",
	Train = "Train",
	Tram = "Tram",
	Union = "Union",
	ViewFinder = "ViewFinder",
	VisionPro = "VisionPro",
	Wall = "Wall",
	Wrench = "Wrench",
	Write = "Write",
	WritingAI = "WritingAI",
	Refresh = "Refresh",
	Comment = "Comment",
	Attachment = "Attachment",
	Blockquote = "Blockquote",
	CodeBlock = "CodeBlock",
	Brick = "Brick",
	Meta = "Meta",
	OpenAI = "OpenAI",
	Email = "Email",
	CameraAi = "CameraAi",
	Checklist = "Checklist",
	Solana = "Solana",
	Brain = "Brain",
	Ai = "Ai",
	AiApp = "AiApp",
	AiDocument = "AiDocument",
	Binocular = "Binocular",
	Bluetooth = "Bluetooth",
	Direction = "Direction",
	Network = "Network",
	Policy = "Policy",
	Routing = "Routing",
	Linear = "Linear",
	Auth0 = "Auth0",
	Chrome = "Chrome",
	Discord = "Discord",
	Edge = "Edge",
	Figma = "Figma",
	Firefox = "Firefox",
	Intercom = "Intercom",
	Notion = "Notion",
	OnePassword = "OnePassword",
	Sentry = "Sentry",
	Slack = "Slack",
	Zapier = "Zapier",
	Zendesk = "Zendesk",
	ClockOutline = "ClockOutline",
	Ethereum = "Ethereum",
	CustomView = "CustomView",
	Initiative = "Initiative",
	IssueStatusBacklog = "IssueStatusBacklog",
	IssueStatusDone = "IssueStatusDone",
	IssueStatusReview = "IssueStatusReview",
	IssueStatusStarted = "IssueStatusStarted",
	IssueStatusTodo = "IssueStatusTodo",
	IssueStatusTriage = "IssueStatusTriage",
	MilestoneNone = "MilestoneNone",
	MilestoneStatusDone = "MilestoneStatusDone",
	MilestoneStatusPlanned = "MilestoneStatusPlanned",
	MilestoneStatusStarted = "MilestoneStatusStarted",
	MyIssues = "MyIssues",
	Anthropic = "Anthropic",
	Claude = "Claude",
	Cursor = "Cursor",
	Ramp = "Ramp",
	AiWriting = "AiWriting",
	AlarmDelete = "AlarmDelete",
	Alarm = "Alarm",
	Anonymous = "Anonymous",
	Astronaut = "Astronaut",
	BarGraph = "BarGraph",
	ChatLine = "ChatLine",
	Biscuit = "Biscuit",
	Diagram = "Diagram",
	ExclamationMark = "ExclamationMark",
	Flag = "Flag",
	GooglePlay = "GooglePlay",
	MicrosoftTeams = "MicrosoftTeams",
	QuestionMark = "QuestionMark",
	Report = "Report",
	ResolvedChat = "ResolvedChat",
	Resolved = "Resolved",
	SmallLock = "SmallLock",
	SoundMuted = "SoundMuted",
	Speedometer = "Speedometer",
	Starred = "Starred",
	Stopwatch = "Stopwatch",
	Automation = "Automation",
}

export const PROJECT_ICON_KEYS = Object.values(ProjectIconKeys)

// Linear has no Cookie icon; its own name for the same glyph is Biscuit.
const LINEAR_ICON_ALIASES: Partial<Record<string, string>> = {
	[ProjectIconKeys.Cookie]: ProjectIconKeys.Biscuit,
}
const KNOWN_ICONS = new Set<string>(PROJECT_ICON_KEYS)

/** The icon to send to Linear, or undefined so Linear keeps its own when ours is unknown there. */
export function toLinearProjectIcon(
	icon: string | null | undefined,
): string | undefined {
	if (!icon) return undefined
	const alias = LINEAR_ICON_ALIASES[icon]
	if (alias) return alias
	return KNOWN_ICONS.has(icon) ? icon : undefined
}
